import { useNewMobileUiFlag } from '../featureFlags';
import { getDeviceType } from './useDeviceManager';
export const useNewMobileUiManager = (): boolean => {
	const newUI = useNewMobileUiFlag();
	const device = getDeviceType();

	if (device?.clientType === 'native') {
		if (newUI.value === 'ios') {
			return device?.deviceType === 'ios';
		} else if (newUI.value === 'android') {
			return device?.deviceType === 'android';
		} else if (newUI.value === 'both') {
			return device?.deviceType === 'android' || device?.deviceType === 'ios';
		}
	}

	return false;
};
